import React from "react";
import { FormattedMessage } from "react-intl";

const TerminatedError = () => {
  return (
    <div className="tvp-w-full tvp-h-auto tvp-bg-white  tvp-my-4 tvp-flex-grow tvp-flex tvp-flex-col tvp-justify-center">
      <h3 className="tvp-mb-3 tvp-font-bold tvp-text-xl tvp-text-center tvp-clr-neutral">
        <FormattedMessage id="component.terminatedError.segment-1.title" />
      </h3>
      <div className="tvp-text-center tvp-w-10/12 tvp-ml-auto tvp-mr-auto">
        <p>
          <FormattedMessage id="component.terminatedError.segment-1.content" />
        </p>
      </div>
      <div className="tvp-text-center tvp-w-10/12 tvp-ml-auto tvp-mr-auto tvp-mt-2">
        <FormattedMessage id="component.terminatedError.segment-1.content-2" />
      </div>
    </div>
  );
};

export default TerminatedError;
